<template>
  <div class="analysisTable">
      <div class="analysisTable__header">
          <div class="analysisTable__header--icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#44A561" d="M22 3H2c-1.09.04-1.96.91-2 2v14c.04 1.09.91 1.96 2 2h20c1.09-.04 1.96-.91 2-2V5a2.074 2.074 0 0 0-2-2m0 16H2V5h20zm-8-2v-1.25c0-1.66-3.34-2.5-5-2.5s-5 .84-5 2.5V17zM9 7a2.5 2.5 0 0 0-2.5 2.5A2.5 2.5 0 0 0 9 12a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 9 7m5 0v1h6V7zm0 2v1h6V9zm0 2v1h4v-1z"/></svg>
          </div>
          <div class="analysisTable__header--title ml-3">Informações básicas</div>
      </div>
      <div class="analysisTable__content" v-if="!isLoading">
          <div class="analysisTable__content--list">
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Nome</div>
                          <div class="item__container--value">{{ name }}</div>
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Nome usual</div>
                          <div class="item__container--value">{{ usualName }}</div>
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Nome formal</div>
                          <div class="item__container--value">{{ standardizedName }}</div>
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">CPF</div>
                          <div class="item__container--value">{{ cpf }}</div>
                          
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Orgão de fiscalização</div>
                          <div class="item__container--value">{{ fiscalization }}</div>
                          
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item no-border">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Status de Regularidade</div>
                          <div class="item__container--value">{{ status }}</div>
                          
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div v-else class="row justify-content-center p-5">
          <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
          </div>
      </div>
  </div>

</template>

<script>
export default {
  name: 'basicEnrichment',
  props: {
      data: {
          type: Object,
          required: true
      },
      count: {
          type: Object,
          required: false
      },
  },
  computed: {
      isLoading() {
        return this.$store.getters["getLoadingAnalysis"]
      },
      name() {
          return this.data && this.data.name ? this.data.name : '---';
      },
      usualName() {
          return this.data && this.data.common_name ? this.data.common_name : '---';
      },
      standardizedName() {
          return this.data && this.data.standardized_name ? this.data.standardized_name : '---';
      },
      fiscalization() {
          return this.data && this.data.tax_id_origin ? this.data.tax_id_origin : '---';
      },
      cpf() {
          return this.data && this.data.tax_id_number ? this.data.tax_id_number : '---';
      },
      status() {
          return this.data && this.data.tax_id_status ? this.data.tax_id_status : '---';
      },
      countEmail() {
          if (!this.count) {
              return 0
          }
          return this.count && this.count.email ? this.count.email : '---';
      },
      countCpf() {
          if (!this.count) {
              return 0
          }
          return this.count && this.count.cpf ? this.count.cpf : '---';
      },

  },
};
</script>

<style scoped lang="scss">
.analysisTable {
  width: 100%;
  margin: 20px 0px 0px 0px;
  border: solid 1px #E5E5E5;
  border-radius: 10px ;
  padding-top: 15px;


  &__header {
      padding: 0px 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center; 
      gap: 10px;
      
      &--icon {
          flex-shrink: 0;
      }

      &--title {
          color: #44A561;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          margin-left: 14px;
      }
  }

  &__content {
      height: auto;
      width: 100%;

      hr {
          background: #E5E5E5;
      }

      &--list {
          height: auto;
          width: 100%;
          margin: 20px 0px;

          .item {
              border-bottom: solid 1px #E5E5E5;
              position: relative;

              &__container {
                  padding: 20px;

                  &--title {
                      color: #B1B1B1;
                      font-size: 0.8em;
                      font-style: normal;
                      font-weight: 400;
                      line-height: normal;
                  }

                  &--value {
                      color: #141414;
                      font-size: 0.9em;
                      font-style: normal;
                      font-weight: 600;
                      line-height: normal;
                      width: calc(100% - 40px);
                      overflow-x: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                  }

                  &--pill {
                      position: absolute;
                      right: 20px;
                      top: 30%;
                      width: auto;
                      font-size: 0.7em;
                      padding: 4px 10px;
                      font-size: 12px;
                      font-style: normal;
                      font-weight: 600;
                      line-height: normal;
                      border-radius: 50px;


                  }
              }

          }

          .no-border .item {
                border-bottom: none;
            }

      }
  }
}

.blue {
  background: rgba(54, 130, 243, 0.10);
  color: #3682F3;
}

.red {
  background: rgba(255, 95, 95, 0.10);
  color: #FF5F5F;
}
</style>